var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26694 11.5669H10.8419V17.5669C10.8419 18.4502 11.9419 18.8669 12.5253 18.2002L18.8336 11.0336C19.3836 10.4086 18.9419 9.43355 18.1086 9.43355H15.5336V3.43355C15.5336 2.55022 14.4336 2.13355 13.8503 2.80022L7.54194 9.96689C7.00027 10.5919 7.44194 11.5669 8.26694 11.5669Z",
    fill: "#2040A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 4.4585H1.75C1.40833 4.4585 1.125 4.17516 1.125 3.8335C1.125 3.49183 1.40833 3.2085 1.75 3.2085H7.58333C7.925 3.2085 8.20833 3.49183 8.20833 3.8335C8.20833 4.17516 7.925 4.4585 7.58333 4.4585Z",
    fill: "#2040A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.7915H1.75C1.40833 17.7915 1.125 17.5082 1.125 17.1665C1.125 16.8248 1.40833 16.5415 1.75 16.5415H6.75C7.09167 16.5415 7.375 16.8248 7.375 17.1665C7.375 17.5082 7.09167 17.7915 6.75 17.7915Z",
    fill: "#EEF0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.125H1.75C1.40833 11.125 1.125 10.8417 1.125 10.5C1.125 10.1583 1.40833 9.875 1.75 9.875H4.25C4.59167 9.875 4.875 10.1583 4.875 10.5C4.875 10.8417 4.59167 11.125 4.25 11.125Z",
    fill: "#EEF0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.3655a0602ad3c132f466d9b863b64194.svg";
export { ForwardRef as ReactComponent };